import styled from "styled-components/macro"
import TableRowSimple from "../../../Ui/Table/TableRowSimple"

type StyledProps = {
  $deleted?: boolean
}

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  button {
    position: absolute;
    right: 0;
    bottom: 2rem;

    svg {
      margin-left: 1rem;
    }
  }
`

export const Row = styled(TableRowSimple)`
  min-height: 7rem;
  padding: 1.5rem 2rem;
  margin: 0 0 2rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &:hover {
    cursor: initial;
    background: ${p => p.theme.colors.white};
  }
`

export const BasePrice = styled.div`
text-decoration: line-through;
`

export const Status = styled.div<StyledProps>`
  background: ${p => p.$deleted ? p.theme.colors.error.background : p.theme.colors.turquoiseDarker};
  color: ${p => p.theme.colors.white};
  font-weight: 700;
  position: absolute;
  transform-origin: 50% 50%;
  font-size: 1.1rem;
  width: 10rem;
  display: flex;
  justify-content: center;
  left: -2.4rem;
  top: 1.3rem;
  rotate: -45deg;

  &:before {
    content: '';
    position: absolute;
    top: -0.1rem;
    right: -0.1rem;
    rotate: 180deg;
    border-top: 2.7rem solid transparent;
    border-left: 2.7rem solid ${p => p.theme.colors.background};
    width: 0;
  }

  :after {
    content: '';
    position: absolute;
    top: -0.1rem;
    left: -0.1rem;
    rotate: 90deg;
    border-top: 2.7rem solid transparent;
    border-left: 2.7rem solid ${p => p.theme.colors.background};
    width: 0;
  }
`

export const BlurRow = styled(Row)`
  filter: blur(0.3rem);
  -webkit-filter: blur(0.3rem);

`

export const ProductImage = styled.img`
  width: 5rem !important;
  display: block;
  flex-shrink: 0;
  border-radius: 0.6rem;
  align-self: flex-start;
`

export const Id = styled.p`
  font-size: 1.1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0.1rem solid ${p => p.theme.colors.grey};
  background: ${p => p.theme.colors.greyLighter};
  border-radius: 0.4rem;
  width: fit-content;
  padding: 0 0.5rem;

  span {
    color: ${p => p.theme.colors.greyDarker};
  }
`

export const TotalsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;

  button {
    width: 12rem;
    margin-bottom: 4rem;
  }

`

export const TotalPrice = styled.div`
display: flex;
  justify-content: space-between;
`

export const Button = styled.div`
  padding: 1rem;
  border: 0.1rem solid ${p => p.theme.colors.grey};
  margin-left: 0.5rem;
  display: flex;
  border-radius: 0.6rem;

  svg {
    height: 2rem;
    fill: ${p => p.theme.colors.greyDarker};
    }

  &:hover {
    cursor: pointer;
    background: ${p => p.theme.colors.grey};
    svg {
      fill: ${p => p.theme.colors.white
      }
    }
`

export const Buttons = styled.div`
display: flex;
  margin-bottom: 2rem;
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`


export const Name = styled.p`
  ${(p) => p.theme.bold};
  margin: 0;
`

export const Container = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  padding: 2rem;
  border-radius: 0.6rem;
`

export const ProviderStatus = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  margin: 2rem 0 1rem 0;

  div {
    display: flex;
    margin-bottom: 1rem;
  }

  span {
    width: 24rem;
    display: flex;
    justify-content: center;
  }
`


